import React from "react";
import "./SoloTrip.css";
import ManaliSoloEscape from "../../assets/ManaliSoloEscape.png";
import RishikeshRetreat  from "../../assets/RishikeshRetreat.png";
import GoaBackpacking from "../../assets/GoaBackpacking.png";
import LadakhRoadAdventure from "../../assets/LadakhRoadAdventure.png";
import DarjeelingHillsWalk from "../../assets/DarjeelingHillsWalk.png";
import PondicherryExplorer from "../../assets/PondicherryExplorer.png";
import { useNavigate } from "react-router-dom";
const soloTrips = [
  {
    img: ManaliSoloEscape,
    title: "Manali Solo Escape",
    desc: "Spend peaceful mornings in the mountains, explore hidden cafes, walk through pine forests, meet fellow travelers, try local food, enjoy river walks, capture scenic sunsets, and experience true freedom while discovering yourself away from busy city life.",
    link: "/tour-package-data",
  },
  {
    img: RishikeshRetreat,
    title: "Rishikesh Retreat",

    desc: "Practice yoga by the Ganga, attend meditation sessions, try thrilling river rafting, explore temples and ashrams, journal your thoughts, enjoy calm evenings, and reconnect with your mind and body during this refreshing spiritual solo journey.",
    link: "/tour-package-data",
  },
  {
    img: GoaBackpacking,
    title: "Goa Backpacking",
    desc: "Relax on sunny beaches, stay in hostels, meet international travelers, ride scooters across coastal roads, explore vibrant nightlife, taste seafood delights, watch colorful sunsets, and create unforgettable memories at your own pace.",

    link: "/tour-package-data",
  },
  {
    img: LadakhRoadAdventure,
    title: "Ladakh Road Adventure",
    desc: "Ride through dramatic landscapes, cross high mountain passes, visit peaceful monasteries, camp under starry skies, photograph stunning lakes, and embrace the thrill of remote travel while discovering courage and independence within yourself.",

    link: "/tour-package-data",
  },
  {
    img: DarjeelingHillsWalk,
    title: "Darjeeling Hills Walk",
    desc: "Wake up to misty mornings, stroll through tea gardens, enjoy toy train rides, sip fresh tea, chat with locals, watch Kanchenjunga views, and slow down life with quiet moments of reflection and natural beauty.",
    link: "/tour-package-data",
  },
  {
    img: PondicherryExplorer,
    title: "Pondicherry Explorer",
    desc: "Cycle through French streets, relax at peaceful beaches, visit cozy cafes, explore art galleries, practice mindfulness, taste delicious bakeries, and enjoy a calm solo escape filled with culture, colors, and seaside charm.",
    link: "/tour-package-data",
  },
];

const SoloTrip = () => {
   const navigate = useNavigate();

  return (
    <div className="solo-main">
      <h1 className="solo-title">Solo Trip Packages</h1>

      <div className="solo-grid">
        {soloTrips.map((trip, index) => (
          <div
            key={index}
            className="solo-card"
            onClick={() =>
              navigate(trip.link, {
                state: { title: trip.title },
              })
            }
          >
            <img src={trip.img} alt={trip.title} />

            <div className="solo-content">
              <h3>{trip.title}</h3>
              <p>{trip.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
export default SoloTrip